const postConstants = {
  FETCTHING_POSTS: "FETCTHING_POSTS",
  POSTINGS: "POSTINGS",
  FETCHED: "FETCHED",
  PENDING_POSTING_REQUEST: 'PENDING_POSTING_REQUEST',
  PENDING_POSTING_SUCCESS: 'PENDING_POSTING_SUCCESS',
  PENDING_POSTING_FAIL: 'PENDING_POSTING_FAIL',
}

export default postConstants;